export abstract class BaseCmsContentModel {
    public name: string;
    public description: string;
    public url: string;
}
